import { useEffect, useState } from "react"
import { getUndertakingDataNode, OffsetDays } from "./UndertakingFuncs";
import { useDispatch } from "react-redux";
// import { reloadUndertakings } from "../../redux/reducer";
import { v4 as uuidv4 } from "uuid";
import { FileTaskItem } from "../../../../libs/taskmanagement/src/taskTypes";
import { getDataReader, RPWDataReader } from "../../livedataFuncs";
import { setUndertakingPreferences } from "../../redux/reducer";

export function getUndertakingTasks(settings: any, dataroot: any): FileTaskItem[] {
    const createDisable = (!settings.enableFu || !settings.taskFu || !settings.enableAuto);
    const complyDisable = (!settings.enableComp || !settings.taskComp || !settings.enableAuto)
    const dataReader = getDataReader(dataroot);
    let appId = dataReader.getAppId();
    const PSM = dataReader.getPSM();
    const undertaking = dataReader.getUndertaking();
    let tasks = []
    let contact = dataReader.getFirmContactID()?.[1] || "user";
    undertaking.forEach(i => {
        const defectId = i.id;
        const num = i.sentDate2 > ""? 2 : i.sentDate1 > ""? 1 : 0;
        const title = i.lender?`${i.name} - ${i.lender}`:`${i.name}`
        let followNode = getUndertakingDataNode(defectId, dataroot);
        if(i.date1 >= "2026-05-14"){
            let create1 = false;
            let task1active = followNode.getAttribute("TaskActive1");
            // if disabled in settings: only display already created tasks
            if(createDisable){
                create1 = task1active === '1';
            } else {
                if(task1active !== '0'){
                    if(task1active !== '1'){
                        followNode.setAttribute("TaskActive1", '1');
                    }
                    create1 = true;
                }
            }
            if(create1){
                tasks.push({
                    appId: appId,
                    title: `1st Follow Up: ${title}`,
                    date: i[`date1`] || "",
                    typeID: 301,
                    matterNumber: "",
                    ownerID: "",
                    // isActivated: i.TaskComplete1 === "1"? 0:1,
                    isActivated: false,
                    noSave: true,
                    defectID: i.id,
                    notes: "UNDERTAKING_TASK:",
                    isCompleted: (i.sentDate1 > "" || i.completedDate > "")? 1 : 0,
                    userResponsible: contact
                });
            }
        }
        if(i.date2 >= "2026-05-14"){
            let create2 = false;
            let task2active = followNode.getAttribute("TaskActive2");
            if(createDisable){
                create2 = task2active === '1';
            } else {
                if(task2active !== '0'){
                    if(task2active !== '1'){
                        followNode.setAttribute("TaskActive2", '1');
                    }
                    create2 = true;
                }
            }
            if(create2){
                tasks.push({
                    appId: appId,
                    title: `2nd Follow Up: ${title}`,
                    date: i[`date2`] || "",
                    typeID: 302,
                    matterNumber: "",
                    ownerID: "",
                    // isActivated: (num == 0 || i.TaskComplete2 === "1")? 0:1,
                    isActivated: false,
                    noSave: true,
                    defectID: i.id,
                    notes: "UNDERTAKING_TASK:",
                    isCompleted: (i.sentDate2 > "" || i.completedDate > "")? 1 : 0,
                    userResponsible: contact
                });
            }
        }
        if(PSM === "S" && i.date2 >= "2026-05-14"){
            let createcomply = false;
            let complyactive = followNode.getAttribute("ComplyActive");
            if(complyDisable){
                createcomply = complyactive === '1';
            } else {
                if(complyactive !== '0'){
                    if(complyactive !== '1'){
                        followNode.setAttribute("ComplyActive", '1');
                    }
                    createcomply = true;
                }
            }
            if(createcomply){
                tasks.push({
                    appId: appId,
                    title: `Comply: ${title}`,
                    date: i.dueDate || "",
                    typeID: 303,
                    matterNumber: "",
                    ownerID: "",
                    isActivated: 1,
                    noSave: true,
                    defectID: i.id,
                    notes: "UNDERTAKING_TASK:",
                    isCompleted: (i.completedDate > "")? 1 : 0,
                    userResponsible: contact
                })
            }
        }
    })
    return tasks;
}

const UndertakingBackground = (props: {dataRootContainer: any, session: any}) => {
    const dispatch = useDispatch();
    let dataroot = props.dataRootContainer?.dataRoot
    const appId = dataroot?.getAttribute('AppID');
    const closing = dataroot?.getAttribute('ClosingDate');
    const prov = props.session.appProvinceShort;
    const firm = props.session.firm.id;
    const sid = props.session.sid
    const [prefs, setPrefs] = useState({offset1: null, offset2: null});
    const dueDate = OffsetDays(closing, 60, prov);

    useEffect(() => {
        const closing = dataroot.getAttribute("ClosingDate")
        const setting = dataroot.getAttribute("DisableUndertakingEmail");
        if(!(setting > "") && closing > ""){
            // first time in file with a closing date
            dataroot.setAttribute("DisableUndertakingEmail", closing < "2026-05-15"?"1":"0")
        }

        // console.log("get backend undertaking")
        if(!props.session || !appId) return;
        fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${prov}/${firm}/undertaking?SessionID=${sid}&AppID=${appId}`)
            .then(response => response.json())
            .then(data => {
                if(data.ok){
                    let res = data.result;
                    // console.log(res)
                    res.forEach(defect => {
                        let dataNode = getUndertakingDataNode(defect.DefectID, dataroot);
                        // console.log(defect, dataNode)
                        if(dataNode){
                            for(const attr of "SentDate1 SentDate2 SentBy1 SentBy2".split(" ")){
                                // console.log(attr, defect[attr])
                                if(defect[attr] > ""){
                                    dataNode.setAttribute(attr, defect[attr]);
                                }
                            }
                        }
                    })
                    // dispatch(reloadUndertakings(Date.now()));
                }
            })
            .catch(error => console.log("error getting undertaking followups: ", error));
        fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${prov}/${firm}/undertakingprep?SessionID=${sid}`)
            .then(response => response.json())
            .then(data => {
                if(data.ok){
                    let result = JSON.parse(data.result);
                    dispatch(setUndertakingPreferences(result));
                    setPrefs({offset1: result.first || 0, offset2: (result.first || 0) + (result.second || 0)});
                }
            })
            .catch(error => console.log("error getting undertaking preferences: ", error));

    }, [props.session, appId]);

    if(prefs.offset1 > 0 && prefs.offset2 > 0){
        // recalculate tasks for undertaking 
        // console.log("undertaking task recalculate")
        let undertakings = dataroot?.selectNodes("Defect[@Undertaking='1']");
        undertakings.forEach(node => {
            // no id so new added defect- calculate followup dates 
            if(!node.getAttribute('DefectId')){
                node.setAttribute('DefectId', uuidv4());
            }
            if(closing > ""){
                let dataNode = node.selectSingleNode('Data');
                if(!dataNode) return;
                let fua = dataNode.selectSingleNode('Followup');
                if(!fua){
                    fua = dataNode.ownerDocument.createElement('Followup');
                    dataNode.appendChild(fua);
                }
                if(!(dataNode.getAttribute("DateCompliedWith") > "")){
                    // console.log("check for custom", fua.getAttribute("CustomDate1"))
                    if(fua.getAttribute("CustomDate1") !== "1"){
                        let d1 = OffsetDays(closing, prefs.offset1, prov);
                        if(d1 > "") fua.setAttribute('Date1', d1);
                    }
                    if(fua.getAttribute("CustomDate2") !== "1"){
                        let d2 = OffsetDays(closing, prefs.offset2, prov);
                        if(d2 > "") fua.setAttribute('Date2', d2);
                    }
                    fua.setAttribute("DueDate", dueDate);
                // console.log("add values to new defect", node.getAttribute('DefectId'), d1, d2);
                }
            }
        })
    } else {
        console.log("cant read preferences")
    }
    return <></>
}

export default UndertakingBackground;